import { Box } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation } from 'react-router'
import { getCurrentCommits } from '../../../../redux/actions/log'
import { getUnreadNotifications } from '../../../../redux/actions/notifications'
import { updateDisplaytime } from '../../../../redux/actions/userdisplaytime'
import { IRootState } from '../../../../redux/types'
import { clientThemeV5 } from '../../styles/themes/ClientTheme'
import SetQueryParams from '../../utils/SetQueryParams'
import CustomSnackBar from '../CustomSnackBar'
import ClientBreadcumb from '../routes/ClientBreadcumb'
import Footer from './Footer'
import Sidebar from './navigation/Sidebar'
import ClientAppBar from './navigation/client/ClientAppBar'
import '../../styles/sass/messagebird.scss'

function ClientLayout() {
  const dispatch = useDispatch()
  const location = useLocation()

  const { user: authUser, error: errorAuth, msg: msgAuth } = useSelector((state: IRootState) => state.auth)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  if (window.location.pathname !== '/biblioteca') localStorage.removeItem('paginate')

  useEffect(() => {
    if (
      localStorage.getItem('accept_terms') === 'true' &&
      authUser !== null &&
      authUser.me &&
      authUser.verification === 1 &&
      location.pathname !== '/terms'
    ) {
      window.location.href = '/terms'
    }

    const userdisplaytime = localStorage.getItem('userdisplaytime')
    if (userdisplaytime) {
      const updateUserdisplaytime = JSON.parse(userdisplaytime)
      dispatch(updateDisplaytime(updateUserdisplaytime))
      localStorage.removeItem('userdisplaytime')
    }

    dispatch(getUnreadNotifications())
    dispatch(getCurrentCommits())
  }, [])

  if (localStorage.getItem('login_redirect')) {
    let tmpPath = localStorage.getItem('login_redirect')
    localStorage.removeItem('login_redirect')
    window.location.href = tmpPath || '/inicio'
  }

  return (
    <ThemeProvider theme={clientThemeV5}>
      <ClientAppBar />
      <ClientBreadcumb />

      <Box id="client-main-container">
        {authUser?.me && userBrands.length > 0 && <Sidebar theme="client" />}

        <Box
          id="main-container"
          sx={[
            { minHeight: '98vh', flexGrow: 1, padding: 0 },
            window.location.pathname === '/inicio' || authUser === null
              ? { width: { xs: '100%' } }
              : { padding: 1, marginLeft: { lg: 30, xl: 30 } }
          ]}
          component="main"
        >
          <Outlet />
        </Box>
      </Box>

      <Footer />
      <CustomSnackBar errors={[errorAuth]} msgs={[msgAuth]} />

      <SetQueryParams />
      {/* <ShowMobileBanner /> */}
    </ThemeProvider>
  )
}

export default ClientLayout
